import { usePersistStorageState } from 'state/persistStorage';

const NAMESPACE = 'cart';
const CART_CHECKOUT_TOKEN_KEY = `${NAMESPACE}:upscribeCheckoutToken`;

export const useCartCheckoutToken = () => usePersistStorageState(CART_CHECKOUT_TOKEN_KEY);
